import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { tv } from 'tailwind-variants';
export default /*@__PURE__*/ _defineComponent({
    __name: 'TooltipTrigger',
    props: {
        className: { default: undefined },
        tag: { default: 'div' }
    },
    setup(__props) {
        const props = __props;
        const tooltipTrigger = tv({
            base: '',
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_resolveDynamicComponent(props.tag), {
                class: _normalizeClass(_unref(tooltipTrigger)({
                    class: props.className,
                }))
            }, {
                default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "default")
                ]),
                _: 3
            }, 8, ["class"]));
        };
    }
});
